import { EyeOutlined, TeamOutlined, UserAddOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

const getNoticeContent = ({ hasRoadmap, hasActiveChildren }) => {
  if (hasActiveChildren) {
    return {
      title: hasRoadmap
        ? 'Choose a default child to keep planning'
        : 'Choose a default child to create the roadmap',
      description: hasRoadmap
        ? 'This roadmap is planned for one child, and toys are matched to their age. Pick the default child in Manage Children to unlock swaps, toy changes, orders and new weeks.'
        : 'Toys are matched to the child’s age. Pick the default child in Manage Children and you can generate the roadmap right after.',
      actionLabel: 'Set Default Child',
      actionIcon: <TeamOutlined />,
    };
  }
  return {
    title: hasRoadmap
      ? 'Add a child to keep planning'
      : 'Add a child to create the roadmap',
    description: hasRoadmap
      ? 'Toys are matched to the child’s age, so swaps, toy changes, orders and new weeks are paused until the child is added.'
      : 'Toys are matched to the child’s age. Add the child the toy expert spoke about and you can generate the roadmap right after.',
    actionLabel: 'Add Child',
    actionIcon: <UserAddOutlined />,
  };
};

const RoadmapLockNotice = ({ hasRoadmap, hasActiveChildren, onAction }) => {
  const { title, description, actionLabel, actionIcon } = getNoticeContent({
    hasRoadmap,
    hasActiveChildren,
  });
  return (
    <div className="roadmap-lock-notice" role="status">
      <span className="roadmap-lock-notice-icon">{actionIcon}</span>
      <div className="roadmap-lock-notice-content">
        <Text strong className="roadmap-lock-notice-title">
          {title}
        </Text>
        <Text type="secondary" className="roadmap-lock-notice-description">
          {description}
        </Text>
        {hasRoadmap && (
          <span className="roadmap-lock-notice-hint">
            <EyeOutlined /> You can still view the plan and order details below.
          </span>
        )}
      </div>
      <Button type="primary" icon={actionIcon} onClick={onAction}>
        {actionLabel}
      </Button>
    </div>
  );
};

export default RoadmapLockNotice;
